module.exports = __webpack_public_path__ + "static/project-coderpad-18a14765ae48a5714b5793e46caa344f.png";